var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-result"},[_c('el-alert',{attrs:{"title":"文件共享成功","type":"success","description":"文件共享已经创建成功，您可以复制链接，发送给自己的好友了","show-icon":"","closable":false}}),_c('div',{staticClass:"qr-code"},[_c('qr',{attrs:{"margin":10,"text":_vm.shareUrl,"colorDark":"#67C23A","colorLight":"#fff","size":200}}),_c('div',[_vm._v("请使用，扫一扫")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }